import { EventArtistRider as GQLItem, EventArtistRiderTypeEnum } from '../../generated/graphql';
import * as Attachment from '../Attachment/Attachment';
import { take } from '../../util';

export const EventArtistRiderType = Object.freeze({
  HOSPITALITY: EventArtistRiderTypeEnum.Hospitality,
  TECH: EventArtistRiderTypeEnum.Tech,
});

export type EventArtistRiderType = (typeof EventArtistRiderType)[keyof typeof EventArtistRiderType];

export type EventArtistRider = {
  id?: number;
  notes?: string;
  riderType?: EventArtistRiderType;
  artistLoadInTime?: string;
  stageSoundCheckTime?: string;
  soundCheckType?: string;
  stagePerformersNumber?: number;
  backstagePassesNumber?: number;
  attachments?: Attachment.Attachment[];
};

export const fromGql = (item: GQLItem): EventArtistRider => ({
  ...take<EventArtistRider>(item, 'id', 'notes', 'artistLoadInTime', 'stageSoundCheckTime', 'soundCheckType', 'stagePerformersNumber', 'backstagePassesNumber'),
  riderType: item.riderType as EventArtistRiderType,
  attachments: item.attachments?.map(Attachment.fromGql) || [],
});
